export default __webpack_public_path__ + "static/media/Y-you Only Live Once.5e1b3f52.png";